import { ref } from "vue";
import { useBapi } from "@/bapi-client";
import { BAPI_COMMANDS } from "@/bapi-client/types/commands";
import { BAPICustomerSupportTicket } from "@/bapi-client/types/customer-support";

export function useCSTickets() {
  const tickets = ref<BAPICustomerSupportTicket[]>([]);
  const loading = ref(false);

  async function getTickets(
    customerId: string,
    filters?: Record<string, string>,
    sortColumn?: string,
    sortDirection?: string,
    pageNumber?: number,
    pageSize?: number,
  ) {
    loading.value = true;
    const response = await useBapi(
      BAPI_COMMANDS.CUSTOMER_SUPPORT_GET_TICKETS,
      customerId,
      filters,
      sortColumn,
      sortDirection,
      pageNumber,
      pageSize,
    );
    if (!response.success) {
      loading.value = false;
      console.error("Failed to fetch tickets", response.error);
      return;
    }
    tickets.value = response.data.tickets;
    loading.value = false;
    return response.data;
  }

  return {
    loading,
    tickets,
    getTickets,
  };
}
